
import './NoImageAvailable.css'; // Ensure you have a CSS file for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function NoImageAvailable() {
    return (
        <div className="no-image-container">
            <div className="no-image-icon-wrapper">
                <FontAwesomeIcon icon="fa-solid fa-circle-exclamation" className='no-image-icon' />
            </div>
            <h4 className="no-image-title">No Image Available</h4>
            <p className="no-image-text">
                The camera feed is currently unavailable. This could be due to a connection issue or the camera being offline.
            </p>
        </div>
    );
}

export default NoImageAvailable;
